<template>
    <ur-modal :title="$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_4')" ref="modal">
        <ur-data-grid :options="options" :headers="headers" :data-source="list" ref="grid"/>
        <div class="box_common">
            <dl class="hbox jc">
                <dt>{{$t('MSG_TXT_AICC_START_SIP_TOTAL_LABEL')}}</dt>
                <dt>{{summary}}</dt>
            </dl>
        </div>
        <template #action>
            <ur-button :text="$t('MSG_BTN_CFRM')" main @click="close"/>
        </template>
    </ur-modal>
</template>
<script>
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

export default {
    name:'PGE_AIM_00004_P01',
    components:{
        urDataGrid,
    },
    props:{
        list:{type:Array},
    },
    data(){
        return{
            headers:[
                {value:'sipNumber', text:this.$t('MSG_TXT_AICC_START_SIP_TABLE_HEADER_1'),
                    customValue:(v,r) => aiccUtils.phoneNumberFormat.format(v) + ' ' + this.$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_2')},
                {value:'channels', text:this.$t('MSG_TXT_AICC_START_SIP_TABLE_HEADER_2'),},
            ],
        }
    },
    computed:{
        gridHeight(){
            if(this.list.length > 4) {
                return 244;
            } else {
                return 49 * this.list.length + 48;
            }
        },
        gridInfinityScroll(){
            if(this.list.length > 4) {
                return true;
            } else {
                return false;
            }
        },
        options(){
            let options = {
                noInfo:true,
                infinityScroll : this.gridInfinityScroll,
                height:this.gridHeight,
                headerHeight:48,
            }
            return options;
        },
        
        summary(){
            let result = '';
            let sipNumberCount = 0;
            let channelsCount = 0;
            for(let index in this.list) {
                sipNumberCount++;
                channelsCount += this.list[index].channels;
            }

            result = this.$t('MSG_TXT_AICC_START_SIP_TOTAL_FORMAT').replace('%(%S1)', sipNumberCount).replace('%(%S2)', channelsCount);
            return result;
        },
    },
    methods:{
        open(){
            this.$refs['grid'].updateHeaders();
            this.$refs['modal'].open();
        },
        close(){
            this.$refs['modal'].close();
        },
        /*
        infinityScroll(){
            if(this.list.length > 4) {
                return true;
            } else {
                return false;
            }
        },
        gridHeight(){
            if(this.list.length > 4) {
                return 244;
            } else {
                return null;
            }
        },
        */
    },
}
</script>
<style scoped>
    .ur-data-grid {
        min-width: 0px;
    }
    .box_common {
        margin-top: 16px;
        line-height: 20px;
        padding: 14px 16px 13px;
        border-radius: 4px;
        background-color: #EFF1F8;
    }
    .jc {
        justify-content: space-between !important;
        align-content: center !important;
    }
    .hbox {
        display: flex;
    }
    ::v-deep .ur-data-grid > .ur-data-grid__table {
        border-bottom: 1px solid #eaeaea;
    }
    ::v-deep .ur-data-grid > .ur-data-grid__table > .ur-data-grid__header > .ur-data-grid__header__wrapper {
        border-bottom: 1px solid #dee1eb;
    }
</style>